import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar, Header } from './Sidebar';
import { useLanguage } from '../../contexts/LanguageContext';
import { cn } from '../../lib/utils';

export function AdminLayout() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const { isRTL } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F4F5F4]">
      <Sidebar 
        isCollapsed={isCollapsed} 
        setIsCollapsed={setIsCollapsed}
        isMobileOpen={isMobileOpen}
        setIsMobileOpen={setIsMobileOpen}
      />
      <div
        className={cn(
          "transition-all duration-300",
          isRTL 
            ? isCollapsed ? "lg:mr-20" : "lg:mr-64"
            : isCollapsed ? "lg:ml-20" : "lg:ml-64"
        )}
      >
        <Header setIsMobileOpen={setIsMobileOpen} />
        <main className="p-4 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
